import { useEffect, useRef } from 'react';
import { changeUserPlan, updateUserProfile } from '@/store/users';
import BasketballLoader from '@/components/feed/BasketballLoader';
import { reportError } from '@/lib/monitoring';

/**
 * Free-only V1: the plan-selection step is skipped. The account is confirmed on
 * the free plan and onboarding completes without showing any pricing screen.
 * Removing this component (and flipping PAID_PLANS_ENABLED) restores the
 * original SelectPlan step untouched.
 */
const FreePlanAutoComplete = ({ userId }: { userId: string }) => {
  const done = useRef(false);

  useEffect(() => {
    if (done.current) return;
    done.current = true;
    (async () => {
      try {
        await changeUserPlan(userId, 'free');
        await updateUserProfile(userId, { profileCompleted: true });
      } catch (error) {
        reportError(error, { source: 'FreePlanAutoComplete' });
      }
    })();
  }, [userId]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background">
      <BasketballLoader />
    </div>
  );
};

export default FreePlanAutoComplete;
